<div class="pad15 withpopupCard card">
    <ul ngbNav #nav="ngbNav" class="nav-pills subtab">
        <li *ngFor="let tab of tabs" class="nav-item">
            <a translate class="nav-link" (click)="selectedDWOTab=tab.id" [ngClass]="{'active': selectedDWOTab===tab.id}">{{tab.label}}</a>
        </li>
    </ul>
</div>
<div class="scrollbar dwo  withpopupCard">
    <ng-cotainer *ngIf="selectedDWOTab===1">
        <app-mechanic-clockin></app-mechanic-clockin>
    </ng-cotainer>
    <ng-cotainer *ngIf="selectedDWOTab===2">
        <app-dwo-diagnose></app-dwo-diagnose>
    </ng-cotainer>
    <ng-cotainer *ngIf="selectedDWOTab===3 && brandName == 'nissan' && isSST">
        <app-sst-checklist></app-sst-checklist>
    </ng-cotainer>
    <ng-cotainer *ngIf="selectedDWOTab===4">
        <app-dwo-checklist [isFromArchive]="isFromArchiveFlag"></app-dwo-checklist>
    </ng-cotainer>
    <ng-cotainer *ngIf="selectedDWOTab===5">
        <app-dwo-documents></app-dwo-documents>
    </ng-cotainer>
    <ng-cotainer *ngIf="selectedDWOTab===6">
        <app-dwo-comments></app-dwo-comments>
    </ng-cotainer>
    <ng-cotainer *ngIf="selectedDWOTab===7">
        <app-mechanic-comments></app-mechanic-comments>
    </ng-cotainer>
</div>
<div class="p-3 bg-light pp-footer-top-brdr">
    <div [ngbNavOutlet]="nav"></div>
    <div class="d-flex flex-sm-row flex-column justify-content-end" *ngIf="showCancel">
        <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate>
            <em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
    </div>
</div>